import { Server as MirageServer } from "miragejs";
import { APPLICATION } from "#/constants";
import { routes } from "./routes";
import { getToken } from "./utils";
export { Response as MirageResponse } from "miragejs";
export type { Request } from "miragejs";

type MakeServerProps = {
  environment?: typeof process.env.NODE_ENV;
  userName?: string;
  userRoles?: string[];
};

/**
 * @function startApiMockServer
 * @description function that starts a MirageJS Mock Server
 * @param environment - Environment type
 * @param userName - Custom user name that will be stored in window object
 * @param userRoles - Custom user roles to test different authentication scenarios
 * @returns Server
 */
export const startApiMockServer = ({
  environment = process?.env?.NODE_ENV ?? "test",
  userName = "mock_user",
  userRoles = [],
}: MakeServerProps) => {
  const token = getToken(userName, userRoles);

  const server = new MirageServer({
    routes: function () {
      routes.bind(this)(token);
    },
    urlPrefix: APPLICATION.BFF_URL,
    environment,
    trackRequests: true,
  });

  return server;
};
